import MasterComponent from "../../../components/Forms"
import moment from 'moment';
import { MasterConfigs } from "../../../interfaces/entity";
import { Button, Card, Flex, Modal, notification, Typography, Dropdown, Menu, message } from "antd";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getData } from "../../../actions/apiCall";
import { formatPriceIndian } from "../../../constants/functions";
import PdfView from "../../../components/custom/PDFView";
import Badge from "../../../components/Badge";
import SmallProfileCard from "../../../components/ContactInfo/SmallProfileCard";
import { constants } from "../../../constants/common";
import DrawerComponent from "../../../components/Forms/Drawer";
import InvoiceDetails from "../../Leads/Invoices/InvoiceDetails";
import InvoiceSummary from "../../../components/InvoiceSummary";
import axios from "axios";
const { DownloadOutlined, FileExcelOutlined, FilePdfOutlined } = require("@ant-design/icons");

const PaidInvoices = () => {
    const [pdfURL, setPDFURL] = React.useState<any>(null);
    const [selectedInvoice, setSelectedInvoice] = React.useState<any>(null);
    const [loading, setLoading] = React.useState(false);
    const [openDrawer, setOpenDrawer] = React.useState(false);
    const [summary, setSummary] = useState<any>(null);
    const [exportLoading, setExportLoading] = useState(false);
    const dispatch = useDispatch();
    const query: any = useSelector((app: any) => app?.app?.query);

    const handleLeadClick = (record) => {
        setSelectedInvoice(record);
        setOpenDrawer(true);
    }

    const onSendInvoice = async () => {
        try {
            if (!selectedInvoice) {
                return
            }
            setLoading(true);
            const resData = await dispatch(getData(`/invoiceJobs/send/mail/${selectedInvoice?._id}`));
            if (resData?.code == 200) {
                notification.success({
                    message: 'Success',
                    description: 'Invoice sent successfully',
                })
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    const handleGSTExport = async (format: 'excel' | 'pdf') => {
        try {
            setExportLoading(true);

            // Build query parameters from current filters
            const queryParams: any = {
                format: format,
                invoiceStatus: 'paid'
            };

            // Add any additional filters from query state
            if (query?.fields) {
                Object.keys(query.fields).forEach(key => {
                    queryParams[key] = query.fields[key];
                });
            }
            if (query?.conditions) {
                Object.keys(query.conditions).forEach(key => {
                    queryParams[key] = query.conditions[key];
                });
            }

            // Make request to export endpoint
            const response = await axios.get(`${process.env.API_URL}/invoiceJobs/export/gst`, {
                params: queryParams,
                responseType: 'blob',
            });

            // Check if response is an error (blob with JSON error message)
            if (response.data.type && response.data.type.includes('application/json')) {
                const text = await response.data.text();
                const errorData = JSON.parse(text);
                throw new Error(errorData.message || 'Failed to export GST data');
            }

            // Create blob and download
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            const extension = format === 'pdf' ? 'pdf' : 'xlsx';
            const filename = `gst_portal_export_${moment().format('YYYY-MM-DD_HH-mm-ss')}.${extension}`;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            message.success(`GST Portal data exported successfully as ${format.toUpperCase()}`);
        } catch (error: any) {
            console.error('Error exporting GST data:', error);
            let errorMessage = 'Failed to export GST data';

            if (error?.response) {
                if (error.response.data instanceof Blob) {
                    try {
                        const text = await error.response.data.text();
                        const errorData = JSON.parse(text);
                        errorMessage = errorData.message || errorMessage;
                    } catch (parseError) {
                        errorMessage = error.message || errorMessage;
                    }
                } else if (error.response.data?.message) {
                    errorMessage = error.response.data.message;
                } else if (typeof error.response.data === 'string') {
                    errorMessage = error.response.data;
                }
            } else if (error?.message) {
                errorMessage = error.message;
            }

            message.error(errorMessage);
        } finally {
            setExportLoading(false);
        }
    };

    const handleTDSExport = async (format: 'excel' | 'pdf') => {
        try {
            setExportLoading(true);

            // Build query parameters from current filters
            const queryParams: any = {
                format: format,
                invoiceStatus: 'paid'
            };

            // Add any additional filters from query state
            if (query?.fields) {
                Object.keys(query.fields).forEach(key => {
                    queryParams[key] = query.fields[key];
                });
            }
            if (query?.conditions) {
                Object.keys(query.conditions).forEach(key => {
                    queryParams[key] = query.conditions[key];
                });
            }

            // Make request to export endpoint
            const response = await axios.get(`${process.env.API_URL}/invoiceJobs/export/tds`, {
                params: queryParams,
                responseType: 'blob',
            });

            // Check if response is an error (blob with JSON error message)
            if (response.data.type && response.data.type.includes('application/json')) {
                const text = await response.data.text();
                const errorData = JSON.parse(text);
                throw new Error(errorData.message || 'Failed to export TDS data');
            }

            // Create blob and download
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            const extension = format === 'pdf' ? 'pdf' : 'xlsx';
            const filename = `tds_export_${moment().format('YYYY-MM-DD_HH-mm-ss')}.${extension}`;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            message.success(`TDS data exported successfully as ${format.toUpperCase()}`);
        } catch (error: any) {
            console.error('Error exporting TDS data:', error);
            let errorMessage = 'Failed to export TDS data';

            if (error?.response) {
                if (error.response.data instanceof Blob) {
                    try {
                        const text = await error.response.data.text();
                        const errorData = JSON.parse(text);
                        errorMessage = errorData.message || errorMessage;
                    } catch (parseError) {
                        errorMessage = error.message || errorMessage;
                    }
                } else if (error.response.data?.message) {
                    errorMessage = error.response.data.message;
                } else if (typeof error.response.data === 'string') {
                    errorMessage = error.response.data;
                }
            } else if (error?.message) {
                errorMessage = error.message;
            }

            message.error(errorMessage);
        } finally {
            setExportLoading(false);
        }
    };

    const invoiceConfig: MasterConfigs = useMemo(() => ({
        api: () => '/invoiceJobs',
        title: 'Paid Invoices',
        queryParams: {
            invoiceStatus: 'paid'
        },
        isActionTab: false,
        maskClosable: false,
        onSummaryLoad: (summaryData) => {
            setSummary(summaryData);
        },
        renderSummary: () => {
            return <InvoiceSummary summary={summary} />;
        },
        getColumns: () => {
            return [
                {
                    title: 'Invoice Number',
                    dataIndex: 'invoiceNumber',
                    key: 'invoiceNumber',
                    width: 150,
                    fixed: 'left',
                    align: 'left',
                    render: (value, records) => {
                        // Get start and end dates from developers array
                        let startDate = null;
                        let endDate = null;

                        if (records?.developers && Array.isArray(records.developers) && records.developers.length > 0) {
                            const dates = records.developers
                                .filter(dev => dev.startDate || dev.endDate)
                                .map(dev => ({
                                    start: dev.startDate ? moment(dev.startDate) : null,
                                    end: dev.endDate ? moment(dev.endDate) : null
                                }));

                            if (dates.length > 0) {
                                const validStarts = dates.map(d => d.start).filter(d => d && d.isValid());
                                const validEnds = dates.map(d => d.end).filter(d => d && d.isValid());

                                if (validStarts.length > 0) {
                                    startDate = moment.min(validStarts);
                                }
                                if (validEnds.length > 0) {
                                    endDate = moment.max(validEnds);
                                }
                            }
                        }

                        return (
                            <div style={{ textAlign: 'left' }}>
                                <div style={{ textAlign: 'left' }}>
                                    <Button type="link" className="text-left !p-0" size="small" onClick={() => handleLeadClick(records)}>{value}</Button>
                                </div>
                                {(startDate || endDate) && (
                                    <div style={{ fontSize: '12px', color: '#8c8c8c', marginTop: '-2px' }}>
                                        {startDate && endDate
                                            ? `${startDate.format('DD MMM')} - ${endDate.format('DD MMM')}, ${endDate.format('YYYY')}`
                                            : startDate
                                                ? `From: ${startDate.format('DD MMM, YYYY')}`
                                                : endDate
                                                    ? `To: ${endDate.format('DD MMM, YYYY')}`
                                                    : ''
                                        }
                                    </div>
                                )}
                            </div>
                        );
                    },
                },
                {
                    title: 'Bill TO',
                    dataIndex: 'billTo',
                    key: 'billTo',
                    fixed: 'left',
                    width: 200,
                    render: (value) => {
                        if (!value) return '-';
                        return (
                            <div>
                                <div>{value.dealName || '-'}</div>
                                {value?.business?.businessName && (
                                    <div style={{ fontSize: '12px', color: '#8c8c8c', marginTop: '2px' }}>
                                        {value.business.businessName}
                                    </div>
                                )}
                            </div>
                        );
                    },
                },
                {
                    title: 'GST Amount',
                    dataIndex: 'gstAmount',
                    key: 'gstAmount',
                    width: 150,
                    render: (value) => {
                        return value ? `₹ ${formatPriceIndian(value)}` : '-';
                    }
                },
                {
                    title: 'TDS Amount',
                    dataIndex: 'tdsAmount',
                    key: 'tdsAmount',
                    width: 150,
                    render: (value) => {
                        return value ? `₹ ${formatPriceIndian(value)}` : '-';
                    }
                },
                {
                    title: 'Bill Amount',
                    dataIndex: 'totalBill',
                    key: 'totalBill',
                    width: 150,
                    render: (value) => {
                        return value ? `₹ ${formatPriceIndian(value)}` : '-';
                    }
                },
                {
                    title: 'Invoice Status',
                    dataIndex: 'invoiceStatus',
                    key: 'invoiceStatus',
                    align: 'center',
                    width: 200,
                    render: (value) => {
                        if (value === 'paid') {
                            return <Badge color="green" text="Paid" />;
                        }
                        return <Badge color="gray" text={value || 'N/A'} />;
                    }
                },
                {
                    title: 'Due Date',
                    dataIndex: 'dueDate',
                    key: 'dueDate',
                    align: 'center',
                    width: 200,
                    render: (value) => {
                        return value ? moment(value).format('DD MMM, YYYY') : '-';
                    },
                },
                {
                    title: 'Invoice Sent On',
                    dataIndex: 'invoiceSentAt',
                    key: 'invoiceSentAt',
                    align: 'center',
                    width: 150,
                    render: (value) => {
                        return value ? moment(value).format('DD MMM, YYYY') : <Badge color="yellow" text="Waiting" />;
                    },
                },
                {
                    title: 'Invoice',
                    dataIndex: 'invoiceFile',
                    key: 'invoiceFile',
                    align: 'center',
                    width: 150,
                    render: (value, record) => {
                        return value ? <Button onClick={() => {
                            setPDFURL(value)
                            setSelectedInvoice(record)
                        }} type="link">View Invoice</Button> : 'No Invoice';
                    },
                },
                {
                    title: 'Created At',
                    dataIndex: 'createdAt',
                    key: 'createdAt',
                    align: 'center',
                    width: 150,
                    render: (value) => {
                        return moment(value).format('LLL');
                    },
                },
                {
                    title: 'Invoice Owner',
                    dataIndex: 'invoiceOwner',
                    key: 'invoiceOwner',
                    align: 'center',
                    width: 150,
                    render: (value) => {
                        return value ? <SmallProfileCard
                            name={constants.GET_FULL_NAME(value)}
                            avatar={value?.avatar}
                        /> : 'No Owner';
                    },
                }
            ];
        },
        getFormColumns: () => [],
        getFilterColumns: () => {
            return [
                {
                    label: 'Account (Client Company)',
                    name: 'billTo',
                    type: 'select',
                    isCombo: true,
                    span: 6,
                    selectProps: {
                        showSearch: true,
                        allowClear: true,
                        placeholder: 'Select Account',
                    },
                },
                {
                    label: 'Developer',
                    name: 'developer',
                    type: 'text',
                    span: 6,
                    placeholder: 'Search by developer name',
                },
                {
                    label: 'Invoice Month',
                    name: 'invoiceMonth',
                    type: 'date',
                    span: 6,
                    dateProps: {
                        picker: 'month',
                        format: 'MMM YYYY',
                        allowClear: true,
                        placeholder: 'Select Month',
                    },
                },
                {
                    label: 'Start Date',
                    name: 'startDate',
                    type: 'date',
                    filterType: 'date',
                    span: 6,
                    dateProps: {
                        format: 'DD MMM, YYYY',
                        allowClear: true,
                        placeholder: 'Select Start Date',
                    },
                },
                {
                    label: 'End Date',
                    name: 'endDate',
                    type: 'date',
                    filterType: 'date',
                    span: 6,
                    dateProps: {
                        format: 'DD MMM, YYYY',
                        allowClear: true,
                        placeholder: 'Select End Date',
                    },
                },
                {
                    label: 'Due Date From',
                    name: 'dueDateFrom',
                    type: 'date',
                    filterType: 'date',
                    span: 6,
                    dateProps: {
                        format: 'DD-MM-YYYY',
                        allowClear: true,
                        placeholder: 'Select due date from',
                    },
                },
                {
                    label: 'Due Date To',
                    name: 'dueDateTo',
                    type: 'date',
                    filterType: 'date',
                    span: 6,
                    dateProps: {
                        format: 'DD-MM-YYYY',
                        allowClear: true,
                        placeholder: 'Select due date to',
                    },
                },
                {
                    label: 'Paid Date From',
                    name: 'paidDateFrom',
                    type: 'date',
                    filterType: 'date',
                    span: 6,
                    dateProps: {
                        format: 'DD-MM-YYYY',
                        allowClear: true,
                        placeholder: 'Paid Date From',
                    },
                },
                {
                    label: 'Paid Date To',
                    name: 'paidDateTo',
                    type: 'date',
                    filterType: 'date',
                    span: 6,
                    dateProps: {
                        format: 'DD-MM-YYYY',
                        allowClear: true,
                        placeholder: 'Paid Date To',
                    },
                },
            ];
        },
        combo: [
            {
                name: 'billTo',
                api: '/invoiceJobs/accounts',
                idKey: '_id',
                render: (text) => `${text.businessName}`,
            },
            {
                name: 'billToFilter',
                api: '/invoiceJobs/accounts',
                idKey: '_id',
                render: (text) => text.businessName || text.name || '',
            },
        ],
        getData: () => ({}),
        actions: [
            {
                actionType: 'filter',
                name: 'Filter',
            },
            {
                name: 'Export',
                actionType: 'Custom',
                render: () => (
                    <Dropdown
                        overlay={
                            <Menu>
                                <Menu.ItemGroup title="GST Portal Export">
                                    <Menu.Item
                                        key="gst-excel"
                                        icon={<FileExcelOutlined style={{ fontSize: '16px', color: '#52c41a' }} />}
                                        onClick={() => handleGSTExport('excel')}
                                        disabled={exportLoading}
                                    >
                                        Export GST as Excel
                                    </Menu.Item>
                                    <Menu.Item
                                        key="gst-pdf"
                                        icon={<FilePdfOutlined style={{ fontSize: '16px', color: '#ff4d4f' }} />}
                                        onClick={() => handleGSTExport('pdf')}
                                        disabled={exportLoading}
                                    >
                                        Export GST as PDF
                                    </Menu.Item>
                                </Menu.ItemGroup>
                                <Menu.Divider />
                                <Menu.ItemGroup title="TDS Export">
                                    <Menu.Item
                                        key="tds-excel"
                                        icon={<FileExcelOutlined style={{ fontSize: '16px', color: '#52c41a' }} />}
                                        onClick={() => handleTDSExport('excel')}
                                        disabled={exportLoading}
                                    >
                                        Export TDS as Excel
                                    </Menu.Item>
                                    <Menu.Item
                                        key="tds-pdf"
                                        icon={<FilePdfOutlined style={{ fontSize: '16px', color: '#ff4d4f' }} />}
                                        onClick={() => handleTDSExport('pdf')}
                                        disabled={exportLoading}
                                    >
                                        Export TDS as PDF
                                    </Menu.Item>
                                </Menu.ItemGroup>
                            </Menu>
                        }
                        trigger={['click']}
                    >
                        <Button
                            type="default"
                            icon={<DownloadOutlined />}
                            loading={exportLoading}
                        >
                            Export
                        </Button>
                    </Dropdown>
                ),
            }
        ]
    }), [summary, query, exportLoading]);

    return <>
        <Modal
            title={"Invoice PDF"}
            open={!!pdfURL} onCancel={() => setPDFURL(null)} width={1000}
            onOk={() => onSendInvoice()}
            okButtonProps={{ loading: loading }}
            okText={"Send Mail"}
        >
            <PdfView url={process.env.FILE_URL + pdfURL} isToolbar={true} />
        </Modal>
        <MasterComponent config={invoiceConfig} />
        <DrawerComponent
            title={
                <Flex justify="space-between" align="center" gap={2} style={{ width: '95%' }}>
                    {selectedInvoice?.invoiceNumber}
                </Flex>
            }
            visible={openDrawer}
            handleCancel={() => setOpenDrawer(false)}
            isView={true}
            loading={false}
            submitForm={() => { }}
            rest={{
                width: '90%', style: {
                    background: '#eef1f9',
                    padding: '0px !important',
                },
                bodyStyle: { padding: 0 },
                headerStyle: { background: '#FFFFFF', padding: '8px 10px' },
            }}
        >
            <InvoiceDetails invoice={selectedInvoice} />
        </DrawerComponent>
    </>
}

export default PaidInvoices;
